import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { dashboardsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { DashboardsListResponse } from "@src/types/dashboards";

export const getDashboardsV2 = async (
  namespace: string,
): Promise<{ data: DashboardsListResponse }> => {
  const url = dashboardsUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<DashboardsListResponse>(
      `${url}/api/v2/ns/${namespace}/dashboards`,
      { headers },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch dashboards. Please try again later.",
      );
    }
    throw new Error("An unexpected error occurred while fetching dashboards.");
  }
};
